import { ADD_CARD_URL, SANDBOX } from '../shared/settings'
import { objectToUrl } from '../utils/url'
import checkIsWebview from '../utils/checkIsWebview'

let addCardTab = null
let resolveMethod = null

const addCard = async (returnUrl) => {
  const params = { theme: 'flyxo' }

  const isWebview = checkIsWebview(window.navigator.userAgent)

  if (isWebview) {
    params['return_url'] = returnUrl
  }

  // Send origin to pass security check (allow cross-domain messages)
  if (!ADD_CARD_URL.includes(window.location.origin)) {
    params.parent_origin = window.location.origin
  }

  // Dev flag calls to new window that it should call DEV Api
  if (SANDBOX !== 'false') params.dev = true

  const tabURL = `${ADD_CARD_URL}${ADD_CARD_URL.includes('?') ? '&' : '?'}${objectToUrl(params)}`

  if (addCardTab) {
    addCardTab.close()
    addCardTab = null
  }

  if (resolveMethod) {
    resolveMethod(null)
    resolveMethod = null
  }

  if (!isWebview) {
    addCardTab = window.open(tabURL)
  } else {
    window.location.href = tabURL
    return null
  }

  return new Promise(resolve => {
    if (!addCardTab) {
      console.error('You must allow popups for this map to work.')
      resolve(null)
      return
    }

    resolveMethod = resolve

    window.addEventListener('message', ({ origin, data: cardId }) => {
      // security check postmessage
      if (ADD_CARD_URL.includes(origin)) resolve(cardId)
    })
  })
}

export default addCard
